<app-layout>
  @if (passwordView) {
    <div primary>
      <h1 class="text-h1 mb-6">
        {{ "password.header" | translate }}
      </h1>
      <p id="password-description">
        {{ "password.body" | translate }}
      </p>

      <div class="mt-10">
        <form
          [formGroup]="passwordForm"
          (ngSubmit)="onSubmit()"
          aria-live="polite"
        >
          <label class="text-base my-2" for="password">{{
            "password.inputheader" | translate
          }}</label>
          <input
            id="password"
            name="password"
            type="password"
            autocomplete="current-password"
            formControlName="password"
            class="border w-full px-2 py-3 bg-[initial] focus:outline"
            [ngClass]="{
              'validation-border':
                (control?.hasError('required') && control?.touched) ||
                (error$ | async),
            }"
            aria-describedby="password-description"
          />
          @if (control?.hasError("required") && control?.touched) {
            <app-icon
              [name]="Icon.Warning"
              class="relative float-right bottom-[1.8rem] validation-dynamic-theme"
            ></app-icon>
          }
          @if (error$ | async; as error) {
            <app-validator [validator]="validator.IncorrectPassword" />
          }
          <div class="min-h-8">
            @if (control?.hasError("required") && control?.touched) {
              <p
                id="required-error"
                class="validation-dynamic-theme pl-2 pr-2 pt-2"
              >
                <span>{{ "validation.password.incorrect" | translate }}</span>
              </p>
            }
          </div>
        </form>
      </div>
    </div>
  }
  @if (chooseLanguageComponent) {
    <app-choose-language
      appLanguage
      class="mr-2 lg:mr-4"
      (selectedLanguage)="setLanguage($event)"
      [defaultLanguage]="response.language"
      [showFlags]="chooseLanguageComponent.showFlags"
      [options]="languageOptions"
      [translationKeys]="passwordPageTranslationkeys"
      [fallbackLanguage]="response.fallbackLanguage"
    ></app-choose-language>
  }

  <app-navigation
    (nextClick)="onSubmit()"
    [disableNext]="passwordForm.invalid"
    [nextButtonText]="'navigation.next.button' | translate"
    navigation
  ></app-navigation>
</app-layout>
